import {Comparator} from "../../../types/GenericTypes";

export enum AchievementName {
    FIRST_LOGIN = "FIRST_LOGIN",
    FIVE_LOGINS = "FIVE_LOGINS",
    TEN_LOGINS = "TEN_LOGINS",
    TWENTY_LOGINS = "TWENTY_LOGINS",

    VISIT_PORTFOLIO_SCREEN = "VISIT_PORTFOLIO_SCREEN",
    VISIT_STRATEGY_BUILDER = "VISIT_STRATEGY_BUILDER",
    VISIT_CHARTING_SCREEN = "VISIT_CHARTING_SCREEN",

    FIRST_ORDER = "FIRST_ORDER",
    AMEND_ORDER = "AMEND_ORDER",
    THREE_TRADES = "THREE_TRADES",
    FIVE_TRADES = "FIVE_TRADES",
    TEN_TRADES = "TEN_TRADES",
    FIFTEEN_TRADES = "FIFTEEN_TRADES",
    TWENTY_TRADES = "TWENTY_TRADES",
    CLOSE_PROFITABLE_TRADE = "CLOSE_PROFITABLE_TRADE",
    CLOSE_LOSING_TRADE = "CLOSE_LOSING_TRADE",

    FIVE_LEAGUE_INVITES = "FIVE_LEAGUE_INVITES",
    TEN_LEAGUE_INVITES = "TEN_LEAGUE_INVITES",
    TWENTY_LEAGUE_INVITES = "TWENTY_LEAGUE_INVITES",
    FIFTY_LEAGUE_INVITES = "FIFTY_LEAGUE_INVITES",
    ONE_HUNDRED_LEAGUE_INVITES = "ONE_HUNDRED_LEAGUE_INVITES",

    CREATE_TRADING_ALERT = "CREATE_TRADING_ALERT",

    TEN_BY_TEN_WATCHED_VIDEO_ONE = "TEN_BY_TEN_WATCHED_VIDEO_ONE",
    TEN_BY_TEN_WATCHED_VIDEO_TWO = "TEN_BY_TEN_WATCHED_VIDEO_TWO",
    TEN_BY_TEN_WATCHED_VIDEO_THREE = "TEN_BY_TEN_WATCHED_VIDEO_THREE",
    TEN_BY_TEN_WATCHED_VIDEO_FOUR = "TEN_BY_TEN_WATCHED_VIDEO_FOUR",
    TEN_BY_TEN_WATCHED_VIDEO_FIVE = "TEN_BY_TEN_WATCHED_VIDEO_FIVE",
    TEN_BY_TEN_WATCHED_VIDEO_SIX = "TEN_BY_TEN_WATCHED_VIDEO_SIX",
    TEN_BY_TEN_WATCHED_VIDEO_SEVEN = "TEN_BY_TEN_WATCHED_VIDEO_SEVEN",
    TEN_BY_TEN_WATCHED_VIDEO_EIGHT = "TEN_BY_TEN_WATCHED_VIDEO_EIGHT",
    TEN_BY_TEN_WATCHED_VIDEO_NINE = "TEN_BY_TEN_WATCHED_VIDEO_NINE",
    TEN_BY_TEN_WATCHED_VIDEO_TEN = "TEN_BY_TEN_WATCHED_VIDEO_TEN",
    TEN_BY_TEN_WATCHED_ALL_VIDEOS = "TEN_BY_TEN_WATCHED_ALL_VIDEOS",

    JOINED_BASIC_WEBCAST = "JOINED_BASIC_WEBCAST",
    JOINED_INTERMEDIATE_WEBCAST = "JOINED_INTERMEDIATE_WEBCAST",
    JOINED_ADVANCED_WEBCAST = "JOINED_ADVANCED_WEBCAST",
    JOINED_WEEK_ONE_WEEKLY_WRAP_WEBCAST = "JOINED_WEEK_ONE_WEEKLY_WRAP_WEBCAST",
    JOINED_WEEK_TWO_WEEKLY_WRAP_WEBCAST = "JOINED_WEEK_TWO_WEEKLY_WRAP_WEBCAST",
    JOINED_WEEK_THREE_WEEKLY_WRAP_WEBCAST = "JOINED_WEEK_THREE_WEEKLY_WRAP_WEBCAST",
    JOINED_ALL_WEEKLY_WRAP_WEBCASTS = "JOINED_ALL_WEEKLY_WRAP_WEBCASTS",

    TRADE_LONG_CALL = "TRADE_LONG_CALL",
    TRADE_LONG_PUT = "TRADE_LONG_PUT",
    TRADE_BULL_CALL = "TRADE_BULL_CALL",
    TRADE_BEAR_CALL = "TRADE_BEAR_CALL",
    TRADE_BULL_PUT = "TRADE_BULL_PUT",
    TRADE_BEAR_PUT = "TRADE_BEAR_PUT",
    TRADE_IRON_CONDOR = "TRADE_IRON_CONDOR",
    TRADE_LITT_LONG = "TRADE_LITT_LONG",
    TRADE_LITT_SHORT = "TRADE_LITT_SHORT"
}

export function achievementMessage(name: AchievementName): string {
    switch (name) {
        case AchievementName.FIRST_LOGIN:
            return "You're locked and loaded";
        case AchievementName.FIVE_LOGINS:
            return "That's 5 days now!";
        case AchievementName.TEN_LOGINS:
            return "Consistent Performer";
        case AchievementName.TWENTY_LOGINS:
            return "Outstanding Dedication";
        case AchievementName.VISIT_CHARTING_SCREEN:
            return "Visit Charting Screen";
        case AchievementName.VISIT_PORTFOLIO_SCREEN:
            return "Visit Portfolio Screen";
        case AchievementName.VISIT_STRATEGY_BUILDER:
            return "Visit Strategy Builder";
        case AchievementName.FIRST_ORDER:
            return "Just warming up";
        case AchievementName.AMEND_ORDER:
            return "Getting things right";
        case AchievementName.THREE_TRADES:
            return "Options Trinity";
        case AchievementName.FIVE_TRADES:
            return "Momentum Builder";
        case AchievementName.TEN_TRADES:
            return "10 works a treat";
        case AchievementName.FIFTEEN_TRADES:
            return "Options master";
        case AchievementName.TWENTY_TRADES:
            return "Probability skewer";
        case AchievementName.CLOSE_PROFITABLE_TRADE:
            return "Winner, winner, chicken...";
        case AchievementName.CLOSE_LOSING_TRADE:
            return "It takes guts to admit a loser";
        case AchievementName.FIVE_LEAGUE_INVITES:
            return "Invited 5 friends";
        case AchievementName.TEN_LEAGUE_INVITES:
            return "Invited 10 friends";
        case AchievementName.TWENTY_LEAGUE_INVITES:
            return "Invited 20 friends";
        case AchievementName.FIFTY_LEAGUE_INVITES:
            return "Invited 50 friends";
        case AchievementName.ONE_HUNDRED_LEAGUE_INVITES:
            return "Invited 100 friends";
        case AchievementName.CREATE_TRADING_ALERT:
            return "Create a Trading Alert";

        case AchievementName.TEN_BY_TEN_WATCHED_VIDEO_ONE:
            return "Now you know my story";
        case AchievementName.TEN_BY_TEN_WATCHED_VIDEO_TWO:
            return "10x10 - 2";
        case AchievementName.TEN_BY_TEN_WATCHED_VIDEO_THREE:
            return "10x10 - 3";
        case AchievementName.TEN_BY_TEN_WATCHED_VIDEO_FOUR:
            return "10x10 - 4";
        case AchievementName.TEN_BY_TEN_WATCHED_VIDEO_FIVE:
            return "10x10 - 5";
        case AchievementName.TEN_BY_TEN_WATCHED_VIDEO_SIX:
            return "10x10 - 6";
        case AchievementName.TEN_BY_TEN_WATCHED_VIDEO_SEVEN:
            return "10x10 - 7";
        case AchievementName.TEN_BY_TEN_WATCHED_VIDEO_EIGHT:
            return "10x10 - 8";
        case AchievementName.TEN_BY_TEN_WATCHED_VIDEO_NINE:
            return "10x10 - 9";
        case AchievementName.TEN_BY_TEN_WATCHED_VIDEO_TEN:
            return "Ruler of margins";
        case AchievementName.TEN_BY_TEN_WATCHED_ALL_VIDEOS:
            return "That's some journey we've been on";

        case AchievementName.JOINED_BASIC_WEBCAST:
            return "Beginner Webcast";
        case AchievementName.JOINED_INTERMEDIATE_WEBCAST:
            return "Intermediate Webcast";
        case AchievementName.JOINED_ADVANCED_WEBCAST:
            return "Advanced Webcast";
        case AchievementName.JOINED_WEEK_ONE_WEEKLY_WRAP_WEBCAST:
            return "Week 1 Wrap";
        case AchievementName.JOINED_WEEK_TWO_WEEKLY_WRAP_WEBCAST:
            return "Week 2 Wrap";
        case AchievementName.JOINED_WEEK_THREE_WEEKLY_WRAP_WEBCAST:
            return "Week 3 Wrap";
        case AchievementName.JOINED_ALL_WEEKLY_WRAP_WEBCASTS:
            return "All Wraps";

        case AchievementName.TRADE_LONG_CALL:
            return "That's bold & bullish";
        case AchievementName.TRADE_LONG_PUT:
            return "That's bold & bearish";
        case AchievementName.TRADE_BULL_CALL:
            return "Calling all bulls";
        case AchievementName.TRADE_BEAR_CALL:
            return "The bear on a pedestal";
        case AchievementName.TRADE_BULL_PUT:
            return "Pull the bull to the ground";
        case AchievementName.TRADE_BEAR_PUT:
            return "Put the bear down";
        case AchievementName.TRADE_IRON_CONDOR:
            return "Unleash the vulture";
        case AchievementName.TRADE_LITT_LONG:
            return "Trade LITT Long";
        case AchievementName.TRADE_LITT_SHORT:
            return "Trade LITT Short";
    }
}

const Order = [
    AchievementName.FIRST_LOGIN,
    AchievementName.FIVE_LOGINS,
    AchievementName.TEN_LOGINS,
    AchievementName.TWENTY_LOGINS,

    AchievementName.VISIT_PORTFOLIO_SCREEN,
    AchievementName.VISIT_STRATEGY_BUILDER,
    AchievementName.VISIT_CHARTING_SCREEN,

    AchievementName.FIRST_ORDER,
    AchievementName.AMEND_ORDER,
    AchievementName.THREE_TRADES,
    AchievementName.FIVE_TRADES,
    AchievementName.TEN_TRADES,
    AchievementName.FIFTEEN_TRADES,
    AchievementName.TWENTY_TRADES,
    AchievementName.CLOSE_PROFITABLE_TRADE,
    AchievementName.CLOSE_LOSING_TRADE,

    AchievementName.FIVE_LEAGUE_INVITES,
    AchievementName.TEN_LEAGUE_INVITES,
    AchievementName.TWENTY_LEAGUE_INVITES,
    AchievementName.FIFTY_LEAGUE_INVITES,
    AchievementName.ONE_HUNDRED_LEAGUE_INVITES,

    AchievementName.CREATE_TRADING_ALERT,

    AchievementName.TEN_BY_TEN_WATCHED_VIDEO_ONE,
    AchievementName.TEN_BY_TEN_WATCHED_VIDEO_TWO,
    AchievementName.TEN_BY_TEN_WATCHED_VIDEO_THREE,
    AchievementName.TEN_BY_TEN_WATCHED_VIDEO_FOUR,
    AchievementName.TEN_BY_TEN_WATCHED_VIDEO_FIVE,
    AchievementName.TEN_BY_TEN_WATCHED_VIDEO_SIX,
    AchievementName.TEN_BY_TEN_WATCHED_VIDEO_SEVEN,
    AchievementName.TEN_BY_TEN_WATCHED_VIDEO_EIGHT,
    AchievementName.TEN_BY_TEN_WATCHED_VIDEO_NINE,
    AchievementName.TEN_BY_TEN_WATCHED_VIDEO_TEN,
    AchievementName.TEN_BY_TEN_WATCHED_ALL_VIDEOS,

    AchievementName.JOINED_BASIC_WEBCAST,
    AchievementName.JOINED_INTERMEDIATE_WEBCAST,
    AchievementName.JOINED_ADVANCED_WEBCAST,
    AchievementName.JOINED_WEEK_ONE_WEEKLY_WRAP_WEBCAST,
    AchievementName.JOINED_WEEK_TWO_WEEKLY_WRAP_WEBCAST,
    AchievementName.JOINED_WEEK_THREE_WEEKLY_WRAP_WEBCAST,
    AchievementName.JOINED_ALL_WEEKLY_WRAP_WEBCASTS,

    AchievementName.TRADE_LONG_CALL,
    AchievementName.TRADE_LONG_PUT,
    AchievementName.TRADE_BULL_CALL,
    AchievementName.TRADE_BEAR_CALL,
    AchievementName.TRADE_BULL_PUT,
    AchievementName.TRADE_BEAR_PUT,
    AchievementName.TRADE_IRON_CONDOR,
    AchievementName.TRADE_LITT_LONG,
    AchievementName.TRADE_LITT_SHORT
];

export function sortAchievementName(): Comparator<AchievementName> {
    return (a, b) => Order.indexOf(a) - Order.indexOf(b);
}
